export enum PageRoutePathsEnum {
  PRIVACY_POLICY = '/privacy-policy',
  TERMS_CONDITIONS = '/terms-conditions',
}
